import { css, cx } from 'emotion';
import React from 'react';
import { useUrgencyHighlights } from './provider';
import { UrgencyHighlightType } from './types';

export const UrgencyHighlights: React.FC = () => {
    const highlight = useUrgencyHighlights();

    return (
        <>
            {highlight[UrgencyHighlightType.EarlyBird] && (
                <div
                    className={cx(
                        styles.base,
                        styles[UrgencyHighlightType.EarlyBird],
                    )}
                >
                    Early access
                </div>
            )}
            {highlight[UrgencyHighlightType.Popular] && (
                <div
                    className={cx(
                        styles.base,
                        styles[UrgencyHighlightType.Popular],
                    )}
                >
                    Popular
                </div>
            )}
            {highlight[UrgencyHighlightType.New] && (
                <div
                    className={cx(
                        styles.base,
                        styles[UrgencyHighlightType.New],
                    )}
                >
                    Just added!
                </div>
            )}
        </>
    );
};

const styles = {
    base: css`
        border-radius: 8px;
        column-gap: 8px;
        color: #1e0a3c;
        display: inline-flex;
        flex-shrink: 0;
        font-weight: 600;
        line-height: 1;
        margin: 4px;
        padding: 7px 12px;
    `,
    [UrgencyHighlightType.EarlyBird]: css`
        background-color: #ffe6be;
    `,
    [UrgencyHighlightType.Popular]: css`
        background-color: #faafa0;
    `,
    [UrgencyHighlightType.New]: css`
        background-color: #cddfd6;
    `,
};
